import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/main.scss'
import './assets/styles/tailwind-generated.css'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import 'moment/locale/es'
import VueApexCharts from 'vue-apexcharts'
import VueQrious from 'vue-qrious'
import VueResource from 'vue-resource'

// Configure Vue
Vue.config.productionTip = false

// Use plugins
Vue.use(VueMoment, {
  moment
})
Vue.use(VueApexCharts)
Vue.use(VueQrious)
Vue.use(VueResource)

// Configure moment locale and timezone
moment.locale('es')
moment.tz.setDefault('America/Bogota')

// Global filters
Vue.filter('formatDate', function (value) {
  if (!value) return ''
  return moment(value).tz('America/Bogota').format('DD/MM/YYYY HH:mm')
})

Vue.filter('formatTemperature', function (value) {
  if (value === null || value === undefined) return '--'
  return `${value.toFixed(1)}°C`
})

Vue.filter('formatHumidity', function (value) {
  if (value === null || value === undefined) return '--'
  return `${value.toFixed(1)}%`
})

Vue.filter('formatLocation', function (value) {
  if (!value) return '--'
  return `${value.lat.toFixed(6)}, ${value.lng.toFixed(6)}`
})

// Global mixins
Vue.mixin({
  methods: {
    showSuccess(message) {
      // Puedes reemplazar esto por un toast propio o alert
      alert(message)
    },
    showError(message) {
      alert(message)
    },
    showWarning(message) {
      alert(message)
    },
    showInfo(message) {
      alert(message)
    },
    confirmAction(message, title = 'Confirmar acción') {
      return window.confirm(message)
    }
  }
})

// Initialize authentication before creating Vue instance
async function initializeApp() {
  try {
    // Check if user is already authenticated
    const isAuthenticated = await store.dispatch('auth/checkAuth')
    if (!isAuthenticated && store.getters['auth/token']) {
      // Si hay token pero la verificación falló, limpiar el estado
      // Invalid token found, cleaning authentication state
      await store.dispatch('auth/logout')
    }
  } catch (error) {
    // Error checking authentication - handled silently
    // Si hay error y hay token, limpiar el estado
    if (store.getters['auth/token']) {
      // Token verification error, cleaning state
      await store.dispatch('auth/logout')
    }
  } finally {
    // Crear la instancia de Vue siempre
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
}

// Start the application
initializeApp() 


// WEBPACK FOOTER //
// ./src/main.js